module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrapper"
    }
  }, [_c('CustomHeader', {
    attrs: {
      "userName": _vm.userName
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grad",
    attrs: {
      "id": "hline"
    }
  }), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('CustomFooter')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-502c888b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 109
// module chunks = 1